<script>
import {ArrowUpIcon,ArrowRightIcon} from 'vue-feather-icons';
import Navbar from "@/components/navbar";
import Footer from "@/components/footer";

export default {
  data() {
    return {
    }
  },
  components: {
    Navbar,
    Footer,
    ArrowUpIcon,
    ArrowRightIcon
  },
  computed: {
  },
  methods: {
  }
}
</script>

<template>
  <div>
    <!-- 네비게이션 글자 하얗게는 :nav-light="true" -->
    <Navbar />

    <section class="section">
      <div class="container">
        <div class="row">

          <!-- 게시글 영역 -->
          <div class="col-lg-12 col-md-6">
            <div class="row">
              test<br />test<br />test<br />test<br />test<br />test<br />test<br />test<br />test<br />
              test<br />test<br />test<br />test<br />test<br />test<br />test<br />test<br />test<br />
              test<br />test<br />test<br />test<br />test<br />test<br />test<br />test<br />test<br />
              test<br />test<br />test<br />test<br />test<br />test<br />test<br />test<br />test<br />
              test<br />test<br />test<br />test<br />test<br />test<br />test<br />test<br />test<br />
            </div>
          </div>
          
        </div>
      </div>
    </section>

    <Footer />

  </div>
</template>
